import React, { useEffect, useRef, useState } from "react";
import Alert from "react-bootstrap/Alert";
import NavHeader from "../nav/NavHeader";
import SideMenu from "../nav/Sidemenu";
import Skeleton from "react-loading-skeleton";
import { FaDownload, FaEdit, FaFileExcel, FaPrint, FaRedo, FaTrash } from "react-icons/fa";
import ReactPaginate from "react-paginate";
import { useReactToPrint } from "react-to-print";
import Logo from "../../assets/img/Daimler_Logo_Text.png";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Form, Row, Col } from "react-bootstrap";
import axios from "axios";
import { DialogActions, DialogContentText } from "@mui/material";
import preloadimg from "../../assets/img/preloader1.gif";
import UserRegistration from "../pageLayouts/UserRegistration";
import Select from "react-select";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Analtyics from "../pageLayouts/Analtyics";
import usePersonaManagement from "../hooks/usePersonaManagement";
import useRoleManagement from "../hooks/useRoleManagement";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import Login from "../auth/Login";
import { useNavigate } from "react-router-dom";
import Exportuserlist from "../layout/Exportuserlist";
import { getRoleDisplayName } from "../RolesAndPersona/RolesAndPersona";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const skeletonStyle = {
  backgroundColor: "#f0f0f0", // Set the background color for the skeleton
  position: "relative",
  overflow: "hidden",
};

const highlighterStyle = {
  position: "absolute",
  top: 0,
  left: "-100%", // Move the highlighter off-screen initially
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 160, 0.1)", // Set the highlighter color and transparency
  animation: "highlight 5.5s infinite linear", // Add animation to create a sliding effect
};

const ManageUser = () => {
  const [isLoading, setIsloading] = useState(true);
  const [issuccess, setsuccess] = useState(false);
  const [iserror, seterror] = useState(false);
  const [query, setQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPagelimit, setPageLimit] = useState(20);
  const [userType, setUsertype] = useState("");
  const [userGroup, setUserGroup] = useState(null);
  const [Deleteinguser, setDeleteinguser] = useState(false);
  const [accessuserType, setAccessUsertype] = useState(
    localStorage.getItem("userType")
  );

  const [userinfo, setuserinfo] = useState([]);
  //update Form
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [UpdateisLoading, setUpdateisLoading] = useState(false);
  const [UpdateuserGroup, setUpdateuserGroup] = useState("");
  const [UpdateRLType, setUpdateRLType] = useState("");
  const [UpdateuserType, setUpdateuserType] = useState("");
  const [EmailAdress, setEmail] = useState("");
  // delete popup
  const [isDelete, setisDelete] = useState(false);
  const [deleteUserEmail, setdeleteUserEmail] = useState("");
  const [Deleteissuccess, setDeleteissuccess] = useState(false);
  const [Addusers, setAddusers] = useState(false);
  const [Addfaqs, setAddfaqs] = useState(false);
  const [selectedOptionsPersona, setselectedOptionsPersona] = useState([]);
  const [selectedPersona, setselectedPersona] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedOptionsData, setselectedOptionsData] = useState([]);
  const [selectedOptionsDataRl, setselectedOptionsDataRl] = useState([]);
  const [selectedPersona1, setselectedPersona1] = useState([]);

  const [Tabvalue, setTabValue] = useState(0);
  const [ResetUpdateuserType, setResetUpdateuserType] = useState("");
  const [ResetselectedOptionsPersona, setResetselectedOptionsPersona] =
    useState([]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    if (newValue === 0) {
      fetchSearchByname();
    }
  };

  //  console.log("selectedOption selectedOptionsselectedOptionsselectedOptionsselectedOptionsselectedOptionsselectedOptionsselectedOptionsselectedOptionss")
  //  console.log(selectedOptions)

  const tabHeader = [
    {
      TabHeader: "User Management",
    },
    {
      TabHeader: "User Registration",
    },
    // {
    //   TabHeader:"FAQs"
    // },
    {
      TabHeader: "Analytics",
    },
  ];

  const passtoken = !localStorage.getItem("access-token-storage") || localStorage.getItem("access-token-storage") === null
    ? null
    : JSON.parse(localStorage.getItem("access-token-storage"))["accessToken"];
  const { instance, accounts } = useMsal();
  const { personaOptions, getPersonaLabel } = usePersonaManagement(passtoken);
  const { roleOptions, getRoleDisplayLabel } = useRoleManagement(passtoken);


  const componentRef_1 = useRef(null);

  const email = localStorage.getItem("myemail");

  const baseurl = `${process.env.REACT_APP_SERVER_URL}/aipd/getUserList `;

  // const baseurl = `http://localhost:8082/aipd/user`

  useEffect(() => {
    if (passtoken === undefined) {
      return; // or any default value you want to return in this case
    }
    fetchSearchByname();
  }, [baseurl, passtoken]);

  const fetchSearchByname = async () => {
    setIsloading(true);

    await fetch(`${baseurl}`, {
      headers: {
        "oidc-token": passtoken,
        Accept: "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          response.json().then((json) => {
            setuserinfo(json);
            setIsloading(false);
            //  console.log(isLoading);
          });
        }
      })
      .catch((err) => {
        setuserinfo(null);
        setIsloading(false);
      });
  };

  const sortedAsc =
    userinfo === null
      ? ""
      : userinfo
        .slice(0)
        .sort((a, b) =>
          b.lastUpdateDateTime.localeCompare(a.lastUpdateDateTime)
        );

  //  const data = sortedAsc === null ? " " : Object.values(sortedAsc);

  //   const arrayOfObjectsWithStringUserGroup = userinfo.map((obj) => {
  //     return { ...obj, userGroup: obj.userGroup.toString() };
  //   });

  // console.log(arrayOfObjectsWithStringUserGroup);

  const search_parameters = ["emailAddress", "createdBy"];
  const filter_by_userType = [
    ...new Set(userinfo.map((item) => item.userType)),
  ];

  const userGroupIds = [
    ...new Set(
      userinfo.map((item) => item.userGroup.map((group) => group.userGroupId))
    ),
  ];
  // const filter_by_userGroup=  [...new Set(userGroupIds)]

  // const arrayOfIntegers = filter_by_userGroup.map((str) => parseInt(str));

  const userGroupName1 = [...new Set(userGroupIds)];
  const resultArray1 = [].concat(...userGroupName1);
  const resultArray = [...resultArray1.flat()];
  const userGroupName = [...new Set(resultArray)];
  userGroupName.sort((a, b) => a - b);

  let filteredData = [];

  filteredData = sortedAsc.filter((obj) => {
    return obj;
  });

  // console.log(typeof(userGroup))

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  function search(sortedAsc) {
    return filteredData.filter(
      (item) =>
        item.userType.includes(userType) &&
        (!userGroup ||
          item.userGroup.some(
            (group) => group.userGroupId === parseInt(userGroup)
          )) &&
        search_parameters.some((parameter) =>
          item[parameter].toString().toLowerCase().includes(query.toLowerCase())
        )
    );
  }

  const printSegment = useReactToPrint({
    content: () => {
      const tableStat_1 = componentRef_1.current.cloneNode(true);

      const PrintElem = document.createElement("div");
      const header = `<img src="${Logo}" style="padding-bottom:2rem" alt="image" class="watermark"/>`;
      PrintElem.innerHTML = header;

      PrintElem.appendChild(tableStat_1);

      return PrintElem;
    },
  });

  const currentData = search(filteredData).slice(
    (currentPage - 1) * currentPagelimit,
    (currentPage - 1) * currentPagelimit + currentPagelimit
  );

  const pageCount = Math.ceil(search(filteredData).length / currentPagelimit);

  const handelepageclick = (data) => {
    setCurrentPage(data.selected + 1);
  };

  const resetAll = () => {
    setQuery("");
    setUserGroup("");
    setUsertype("");
    setCurrentPage(1);
  };

  const getUserDetail = (email, usersGroup, usersType, RLType) => {
    setOpen(true);
    const selectedValues = usersGroup.map((option) => option.userGroupId);
    const selectedValuesRL = RLType.map((option) => option.RLtypename);

    const transformedArray = usersGroup.map((item) => ({
      value: item.userGroupId,
      label: getPersonaLabel(item.userGroupId),
    }));

    const transformedArrayRL = RLType.map((item) => ({
      value: item.RLtypename,
      label: getRoleDisplayLabel(item) || item.RLtypename,
    }));

    // console.log(transformedArrayRL);
    setUpdateuserGroup(usersGroup);
    setUpdateRLType(RLType);
    setUpdateuserType(usersType);
    setEmail(email);
    setselectedPersona(selectedValues);
    setselectedOptionsPersona(transformedArray);
    setResetselectedOptionsPersona(transformedArray);
    setResetUpdateuserType(usersType);

    setSelectedOptions(transformedArrayRL);

    const userGroupsArray = selectedValues.map((value) => ({
      userGroupId: value,
    }));

    setselectedPersona1(userGroupsArray);

    const userGroupsArrayRLtype = selectedValuesRL.map((value) => ({
      RLtypename: value,
    }));
    setselectedOptionsDataRl(userGroupsArrayRLtype);
  };

  const handleClose = (e) => {
    e.preventDefault();
    setOpen(false);
    setValidated(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    // console.log(form);
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      setValidated(true);
      setUpdateisLoading(true);

      const data = {
        emailAddress: EmailAdress,
        userType: UpdateuserType,
        userGroup: selectedPersona1,
        rlType: selectedOptionsDataRl,
        assignUser: email,
      };
      const url = `${process.env.REACT_APP_SERVER_URL}/aipd/updateUser`;
      // const url = `http://localhost:8082/users`;

      const header = {
        headers: {
          "oidc-token": passtoken,
        },
      };
      axios
        .post(url, data, header)

        .then(function (response) {
          if (response.status === 200) {
            // console.log(response);
            fetchSearchByname();
            setUpdateisLoading(false);
            setValidated(false);
            setsuccess(true);
            setTimeout(() => {
              setsuccess(false);
            }, 10000);
            seterror(false);
            setOpen(!open);
            // window.location.reload();
          }
        })
        .catch(function (error) {
          // console.log(error);
          setUpdateisLoading(false);
          setValidated(false);
          setsuccess(false);
          seterror(true);
          setTimeout(() => {
            seterror(false);
          }, 10000);
        });
    }
    setValidated(true);
  };

  const resetForm = (e) => {
    e.preventDefault();
    setValidated(false);
    setselectedOptionsPersona(ResetselectedOptionsPersona);
    setUpdateuserType(ResetUpdateuserType);
  };

  const isDeleteUser = (email) => {
    setdeleteUserEmail(email);
    setisDelete(!isDelete);
  };

  const deleteusersinfo = () => {
    setisDelete(!isDelete);
    setDeleteinguser(true);
    const deleteUrl = `${process.env.REACT_APP_SERVER_URL}/aipd/deleteUser`;

    const header = {
      headers: {
        "oidc-token": passtoken,
      },
    };

    const data = {
      emailAddress: deleteUserEmail,
    };
    axios
      .post(deleteUrl, data, header)
      .then((response) => {
        // console.log('Resource successfully deleted:');
        setDeleteissuccess(true);
        setDeleteinguser(false);

        fetchSearchByname();
        setTimeout(() => {
          setDeleteissuccess(false);
        }, 5000);
      })

      .catch((error) => {
        // console.error('Error deleting resource:', error);
        setDeleteinguser(false);
      });
  };

  const handleChangePersona = (selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option.value);
    setselectedOptionsPersona(selectedOptions);
    setselectedPersona(selectedValues);
    const userGroupsArray = selectedValues.map((value) => ({
      userGroupId: value,
    }));

    setselectedPersona1(userGroupsArray);
  };

  const handleChange = (selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option.value);
    setSelectedOptions(selectedOptions);
    setselectedOptionsData(selectedValues);
    const userGroupsArrayRLtype = selectedValues.map((value) => ({
      RLtypename: value,
    }));
    setselectedOptionsDataRl(userGroupsArrayRLtype);
  };

  const baseurlFaqs = `${process.env.REACT_APP_SERVER_URL}/aipd/completeTracking`;
  const [dataItems, setData] = useState();
  const [DataLoading, setDataLoading] = useState(true);

  const GetFaqsLsit = async () => {
    try {
      const response = await fetch(baseurlFaqs, {
        headers: {
          Accept: "application/json",
          "oidc-token": passtoken,
        },
      });

      if (response.ok) {
        const jsonData = await response.json();
        // console.log(jsonData);
        setData(...jsonData);
        setDataLoading(false);
        setIsloading(false);
      } else {
        setData([]);
        setIsloading(false);
      }
    } catch (err) {
      console.error("Error:", err);
      setIsloading(false);
      setData([]);
    }
  };

  useEffect(() => {
    GetFaqsLsit();
  }, [passtoken, baseurlFaqs]);

  // console.log("Data is selectedChart");
  // console.log(dataItems);

  return (
    <div>
      <AuthenticatedTemplate>
        <div id="AdminPage">
          <NavHeader />
          <SideMenu />
          {true ? (
            <>
              <div style={{ position: "relative" }} id="main">
                <Box sx={{ width: "100%" }}>
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs
                      id="TabsItems"
                      value={Tabvalue}
                      onChange={handleTabChange}
                      aria-label="basic tabs example"
                    >
                      {tabHeader.map((tabs, index) => {
                        return (
                          <Tab
                            key={index}
                            label={tabs.TabHeader}
                            {...a11yProps(index)}
                          />
                        );
                      })}
                    </Tabs>
                  </Box>

                  <CustomTabPanel
                    className="TabPannel"
                    value={Tabvalue}
                    index={0}
                  >
                    <div id="Create_users_id">
                      <div className="wrapper">
                        <div
                          style={{ paddingBottom: "0rem" }}
                          className="searchBarSections"
                        >
                          <div
                            style={{
                              display: "flex",
                              gridGap: "10px",
                              alignContent: "center",
                              alignItems: "center",
                              position: "absolute",
                              right: "30px",
                              top: "30px",
                            }}
                          >
                            <Exportuserlist
                              excelData={search(filteredData)}
                              fileName={`user_details_${new Date().getTime()}`}
                              title="Export"
                            />
                            <Button
                              onClick={printSegment}
                              title="Print"
                              style={{
                                borderRadius: "6px",
                                color: "white",
                                cursor: "pointer",
                                width: "auto",
                              }}
                              className="submit_btn"
                            >
                              <div
                                style={{
                                  display: "flex",
                                  gridGap: "10px",
                                  alignContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <span>
                                  <FaPrint fontSize={20} />
                                </span>
                              </div>
                            </Button>

                            <Button
                              onClick={fetchSearchByname}
                              title="Print"
                              style={{
                                borderRadius: "6px",
                                color: "white",
                                cursor: "pointer",
                                width: "auto",
                                textTransform: "inherit",
                              }}
                              className="submit_btn"
                            >
                              <div
                                style={{
                                  display: "flex",
                                  gridGap: "10px",
                                  alignContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <span>Refresh</span>
                              </div>
                            </Button>
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            paddingBottom: "0rem",
                            justifyContent: "space-between",
                            flexWrap: "wrap",
                            gridGap: "10px",
                          }}
                        >
                          <div
                            style={{ width: "30%" }}
                            className="search-wrapper"
                          >
                            <input
                              type="search"
                              name="search-form"
                              id="search-form"
                              autoComplete="off"
                              value={query}
                              className="SearchBox_new"
                              placeholder="Search for Email, Assigned By"
                              onChange={(e) => {
                                setQuery(e.target.value);
                                handlePageChange({ selected: 1 });
                              }}
                            />
                          </div>

                          <div style={{ display: "flex", gridGap: "20px" }}>
                            <div className="selectParent select">
                              <select
                                value={userType}
                                onChange={(e) => {
                                  setUsertype(e.target.value);
                                  handlePageChange({ selected: 1 });
                                }}
                                className="custom-select"
                                aria-label="Filter user type"
                              >
                                <option value="">Filter by User Type</option>
                                {filter_by_userType.map((item, index) => (
                                  <option key={index} value={item}>
                                    {item}
                                  </option>
                                ))}
                              </select>
                              <span className="focus"></span>
                            </div>

                            <div className="selectParent select">
                              <select
                                value={userGroup}
                                onChange={(e) => {
                                  setUserGroup(e.target.value);
                                  handlePageChange({ selected: 1 });
                                }}
                                className="custom-select"
                                aria-label="Filter by user group"
                              >
                                <option value="">Filter by User Group</option>
                                {userGroupName.map((item, index) => (
                                  <option key={index} value={item}>
                                    {getPersonaLabel(item)}
                                  </option>
                                ))}
                              </select>
                              <span className="focus"></span>
                            </div>

                            <div>
                              <Button
                                title="Reset all filters"
                                style={{
                                  borderRadius: "6px",
                                  textTransform: "capitalize",
                                  fontSize: "16px",
                                  display: "flex",
                                  gridGap: "10px",
                                  alignContent: "center",
                                  alignItems: "center",
                                  background: "#0000a0",
                                  padding: "8px",
                                  color: "white",
                                  fontWeight: "600",
                                  width: "auto",
                                }}
                                className="submit_btn"
                                onClick={resetAll}
                              >
                                <FaRedo />
                              </Button>
                            </div>
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            paddingBottom: "1rem",
                            paddingTop: "1rem",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              gridGap: "10px",
                              alignContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{
                                fontSize: "18px",
                                paddingBottom: "1rem",
                                paddingTop: "1rem",
                              }}
                            >
                              Total number of Users:{" "}
                              <span
                                style={{
                                  fontSize: "18px",
                                  fontWeight: "600",
                                  color: "#a3172f ",
                                }}
                              >
                                {search(filteredData).length}
                              </span>
                            </div>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              gridGap: "10px",
                              alignItems: "center",
                              alignContent: "center",
                            }}
                          >
                            <div>
                              <ReactPaginate
                                previousLabel={"Previous"}
                                nextLabel={"Next"}
                                breakLabel={"..."}
                                pageCount={pageCount}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={3}
                                onPageChange={handelepageclick}
                                containerClassName={"pagination"}
                                pageClassName={"page-item"}
                                pageLinkClassName={"page-link"}
                                previousClassName={"page-item"}
                                previousLinkClassName={"page-link"}
                                nextClassName={"page-item"}
                                nextLinkClassName={"page-link"}
                                breakClassName={"page-item"}
                                breakLinkClassName={"page-link"}
                                activeClassName={"active"}
                                forcePage={currentPage - 1}
                              />
                            </div>
                          </div>
                        </div>

                        {isLoading && (
                          <table style={{ width: "100%" }}>
                            <tbody>
                              <tr>
                                <th
                                  style={{
                                    background: "#d0d8e2",
                                    color: "#253978",
                                    width: "29%",
                                  }}
                                >
                                  Email
                                </th>

                                <th
                                  style={{
                                    background: "#d0d8e2",
                                    color: "#253978",
                                    width: "20%",
                                  }}
                                >
                                  Assigned By
                                </th>

                                <th
                                  style={{
                                    textAlign: "center",
                                    background: "#d0d8e2",
                                    color: "#253978",
                                    width: "8%",
                                  }}
                                >
                                  User Type
                                </th>
                                <th
                                  style={{
                                    textAlign: "center",
                                    background: "#d0d8e2",
                                    color: "#253978",
                                    width: "10%",
                                  }}
                                >
                                  User Group
                                </th>

                                <th
                                  className="notinPrint"
                                  style={{
                                    textAlign: "center",
                                    background: "#d0d8e2",
                                    color: "#253978",
                                    width: "4%",
                                  }}
                                ></th>
                              </tr>

                              {Array.from({ length: 6 }, (_, i) => (
                                <tr key={i}>
                                  <td>
                                    <div style={skeletonStyle}>
                                      <Skeleton height={20} />
                                      <div style={highlighterStyle}></div>
                                    </div>
                                  </td>
                                  <td>
                                    <div style={skeletonStyle}>
                                      <Skeleton height={20} />
                                      <div style={highlighterStyle}></div>
                                    </div>
                                  </td>
                                  <td>
                                    <div style={skeletonStyle}>
                                      <Skeleton height={20} />
                                      <div style={highlighterStyle}></div>
                                    </div>
                                  </td>
                                  <td>
                                    <div style={skeletonStyle}>
                                      <Skeleton height={20} />
                                      <div style={highlighterStyle}></div>
                                    </div>
                                  </td>

                                  <td>
                                    <div style={skeletonStyle}>
                                      <Skeleton height={20} />
                                      <div style={highlighterStyle}></div>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}

                        {!isLoading && (
                          <table
                            id="DataTable"
                            ref={componentRef_1}
                            style={{ width: "100%" }}
                          >
                            <tbody>
                              <tr>
                                <th
                                  style={{
                                    background: "#d0d8e2",
                                    color: "#253978",
                                    width: "17%",
                                  }}
                                >
                                  Email
                                </th>

                                <th
                                  style={{
                                    background: "#d0d8e2",
                                    color: "#253978",
                                    width: "17%",
                                  }}
                                >
                                  Assigned By
                                </th>

                                <th
                                  style={{
                                    textAlign: "center",
                                    background: "#d0d8e2",
                                    color: "#253978",
                                    width: "10%",
                                  }}
                                >
                                  User Type
                                </th>

                                <th
                                  style={{
                                    textAlign: "center",
                                    background: "#d0d8e2",
                                    color: "#253978",
                                    width: "15%",
                                  }}
                                >
                                  Roles
                                </th>
                                <th
                                  style={{
                                    textAlign: "center",
                                    background: "#d0d8e2",
                                    color: "#253978",
                                    width: "32%",
                                  }}
                                >
                                  User Group
                                </th>

                                <th
                                  className="notinPrint"
                                  style={{
                                    textAlign: "center",
                                    background: "#d0d8e2",
                                    color: "#253978",
                                    width: "5%",
                                  }}
                                >
                                  Actions
                                </th>
                              </tr>

                              {search(filteredData).length !== 0 && (
                                <>
                                  {currentData.map((item, index) => (
                                    <tr key={index}>
                                      <td>
                                        <div
                                          title={item.emailAddress}
                                          style={{
                                            display: "grid",
                                            justifyContent: "start",
                                            fontWeight: "500",
                                          }}
                                        >
                                          <span className="user_items_cls items_cls font-size-new">
                                            {item.emailAddress.toLowerCase()}
                                          </span>
                                        </div>
                                      </td>

                                      <td style={{ fontWeight: "normal" }}>
                                        <span
                                          style={{
                                            display: "grid",
                                            justifyContent: "start",
                                          }}
                                          title={item.createdBy}
                                        >
                                          <span className="user_items_cls items_cls font-size-new">
                                            {item.createdBy}
                                          </span>
                                        </span>
                                      </td>

                                      <td style={{ fontWeight: "normal" }}>
                                        <span
                                          style={{
                                            display: "grid",
                                            justifyContent: "center",
                                          }}
                                        >
                                          <span className="user_items_cls items_cls font-size-new">
                                            {item.userType}
                                          </span>
                                        </span>
                                      </td>

                                      <td style={{ fontWeight: "normal" }}>
                                        <span
                                          style={{
                                            display: "flex",
                                            gridGap: "10px",
                                            flexWrap: "wrap",
                                            justifyContent: "center",
                                          }}
                                        >
                                          {item &&
                                            item.rlType &&
                                            item.rlType.length !== 0 &&
                                            item.rlType.map((role) => {
                                              const roleName = getRoleDisplayLabel(role);
                                              const mappedCode = getRoleDisplayName(roleName);
                                              const displayName =
                                                mappedCode && mappedCode !== roleName
                                                  ? `${roleName} (${mappedCode})`
                                                  : roleName;
                                              return (
                                                <>
                                                  <span
                                                    className={`   ${"user_items_cls items_cls font-size-new"}`}
                                                    title={displayName}
                                                  >
                                                    {displayName}
                                                  </span>
                                                </>
                                              );
                                            })}

                                          {item &&
                                            item.rlType &&
                                            item.rlType.length === 0 && (
                                              <>N/A</>
                                            )}
                                        </span>
                                      </td>
                                      <td style={{ fontWeight: "normal" }}>
                                        <span
                                          style={{
                                            display: "flex",
                                            gridGap: "10px",
                                            flexWrap: "wrap",
                                            justifyContent: "center",
                                          }}
                                        >
                                          {item.userGroup.map((group) => {
                                            return (
                                              <>
                                                <span
                                                  className="user_items_cls items_cls font-size-new"
                                                  title={getPersonaLabel(group.userGroupId)}
                                                >
                                                  {getPersonaLabel(group.userGroupId)}
                                                </span>
                                              </>
                                            );
                                          })}
                                        </span>
                                      </td>

                                      <td
                                        className="notinPrint"
                                        style={{ fontWeight: "normal" }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            gap: "2rem",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            alignContent: "center",
                                          }}
                                        >
                                          <span
                                            style={{
                                              display: "grid",
                                              justifyContent: "center",
                                              cursor: "pointer",
                                            }}
                                            onClick={(e) =>
                                              getUserDetail(
                                                item.emailAddress,
                                                item.userGroup,
                                                item.userType,
                                                item.rlType
                                              )
                                            }
                                          >
                                            <FaEdit title="edit" />
                                          </span>

                                          <span
                                            style={{
                                              display: "grid",
                                              justifyContent: "center",
                                              cursor: "pointer",
                                            }}
                                            onClick={(e) =>
                                              isDeleteUser(item.emailAddress)
                                            }
                                          >
                                            <FaTrash
                                              title="Delete"
                                              color="red"
                                            />
                                          </span>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </>
                              )}

                              {search(filteredData).length === 0 && (
                                <tr style={{ textAlign: "center" }}>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      color: "red",
                                    }}
                                    rowSpan={4}
                                    colSpan={9}
                                  >
                                    No users available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        )}
                      </div>
                    </div>

                    {issuccess && (
                      <div>
                        <Alert
                          style={{
                            position: "absolute",
                            right: "20px",
                            top: "14px",
                          }}
                          variant="success"
                        >
                          <p className="mb-0">
                            User Details Successfully Updated
                          </p>
                        </Alert>
                      </div>
                    )}

                    {iserror && (
                      <div>
                        <Alert
                          style={{
                            position: "absolute",
                            right: "20px",
                            top: "14px",
                          }}
                          variant="danger"
                        >
                          <p className="mb-0">
                            Something went wrong!! Please try after sometime{" "}
                          </p>
                        </Alert>
                      </div>
                    )}

                    {open && (
                      <>
                        <Dialog open={open} onClose={handleClose}>
                          {UpdateisLoading && (
                            <>
                              <DialogTitle>Updating Details </DialogTitle>
                              <DialogContent>
                                <span>Please Wait...</span>
                              </DialogContent>
                            </>
                          )}

                          {!UpdateisLoading && (
                            <>
                              <DialogTitle
                                style={{
                                  background: "#A70E13",
                                  color: "#fff",
                                  fontWeight: "500",
                                }}
                              >
                                Update Details{" "}
                              </DialogTitle>
                              <DialogContent style={{ marginTop: "16px" }}>
                                <Form
                                  noValidate
                                  validated={validated}
                                  onSubmit={handleSubmit}
                                >
                                  <Row className="mb-3">
                                    <Form.Group
                                      as={Col}
                                      controlId="validationCustom01"
                                    >
                                      <Form.Label>Email</Form.Label>
                                      <Form.Control
                                        autoComplete="off"
                                        type="email"
                                        placeholder="Email Address"
                                        value={EmailAdress}
                                        disabled={true}
                                        style={{ cursor: "no-drop" }}
                                      />
                                    </Form.Group>
                                  </Row>

                                  <Row className="mb-3">
                                    <Form.Group
                                      as={Col}
                                      controlId="validationCustom02"
                                    >
                                      <Form.Label>User Type *</Form.Label>

                                      <Form.Select
                                        required
                                        value={`${UpdateuserType}`}
                                        onChange={(e) =>
                                          setUpdateuserType(e.target.value)
                                        }
                                      >
                                        <option value="Member">Member</option>
                                        <option value="Admin">Admin</option>
                                      </Form.Select>
                                      <Form.Control.Feedback type="invalid">
                                        User Type is required *
                                      </Form.Control.Feedback>
                                    </Form.Group>
                                  </Row>

                                  <Row className="mb-3">
                                    <Form.Group
                                      as={Col}
                                      controlId="validationCustom03"
                                    >
                                      <Form.Label>Group Type *</Form.Label>

                                      <Select
                                        isMulti
                                        options={personaOptions}
                                        required
                                        value={selectedOptionsPersona}
                                        onChange={handleChangePersona}
                                      ></Select>
                                      <Form.Control.Feedback type="invalid">
                                        Group Type is required *
                                      </Form.Control.Feedback>
                                    </Form.Group>
                                  </Row>

                                  <Row className="mb-3">
                                    <Form.Group
                                      as={Col}
                                      controlId="validationCustom04"
                                    >
                                      <Form.Label>Roles *</Form.Label>

                                      <Select
                                        options={roleOptions}
                                        required
                                        isMulti
                                        value={selectedOptions}
                                        onChange={handleChange}
                                      ></Select>
                                      <Form.Control.Feedback type="invalid">
                                        Roles is required *
                                      </Form.Control.Feedback>
                                    </Form.Group>
                                  </Row>

                                  <div
                                    style={{
                                      gridGap: "10px",
                                      display: "flex",
                                      marginTop: "2rem",
                                    }}
                                    className="mb-3"
                                  >
                                    <Button
                                      style={{ color: "white" }}
                                      className="submit_btn"
                                      type="submit"
                                    >
                                      Update
                                    </Button>
                                    <Button
                                      style={{ color: "white" }}
                                      onClick={resetForm}
                                      className="cancel_btn"
                                      type="reset"
                                    >
                                      {" "}
                                      Reset
                                    </Button>

                                    <Button
                                      style={{ color: "white" }}
                                      onClick={handleClose}
                                      className="cancel_btn"
                                      type="Cancel"
                                    >
                                      {" "}
                                      Close
                                    </Button>
                                  </div>
                                </Form>
                              </DialogContent>
                            </>
                          )}
                        </Dialog>
                      </>
                    )}

                    {isDelete && (
                      <Dialog
                        open={isDelete}
                        onClose={(e) => setisDelete(!isDelete)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                      >
                        <DialogTitle id="alert-dialog-title">
                          Are you sure you want to delete this user{" "}
                          {deleteUserEmail}?
                        </DialogTitle>
                        <DialogContent>
                          <DialogContentText id="alert-dialog-description">
                            <span>
                              If you are certain about deleting this User, click
                              "OK." Otherwise, click "Cancel" to keep the Users
                              intact.
                            </span>
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <Button
                            className="cancel_btn"
                            onClick={(e) => setisDelete(!isDelete)}
                          >
                            Cancel
                          </Button>
                          <Button
                            className="submit_btn"
                            style={{ color: "#fff" }}
                            onClick={deleteusersinfo}
                            autoFocus
                          >
                            Ok
                          </Button>
                        </DialogActions>
                      </Dialog>
                    )}

                    {Deleteissuccess && (
                      <div>
                        <Alert
                          style={{
                            position: "absolute",
                            right: "20px",
                            top: "14px",
                          }}
                          variant="success"
                        >
                          <p className="mb-0">
                            {deleteUserEmail} User Details Deleted Successfully
                          </p>
                        </Alert>
                      </div>
                    )}

                    {Deleteinguser && (
                      <div
                        style={{
                          position: "fixed",
                          background: "rgba(0,0,0,0.8)",
                          width: "100%",
                          height: "100%",
                          top: "0",
                          left: "0",
                          right: "0",
                          bottom: "0",
                          display: "grid",
                          justifyContent: "center",
                          alignItems: "center",
                          color: "white",
                          zIndex: "99999",
                          justifyItems: "center",
                          alignContent: "center",
                        }}
                      >
                        <img width={200} src={preloadimg} alt="Loading" />
                        <span>Deleting User Please wait...</span>
                      </div>
                    )}
                  </CustomTabPanel>

                  <CustomTabPanel
                    className="TabPannel2"
                    value={Tabvalue}
                    index={1}
                  >
                    <UserRegistration />
                  </CustomTabPanel>

                  {/* <CustomTabPanel className="TabPannel3" value={Tabvalue} index={2}>
                <AddFaqs />
              </CustomTabPanel> */}

                  <CustomTabPanel
                    className="TabPannel4"
                    value={Tabvalue}
                    index={2}
                  >
                    {!DataLoading && (
                      // <LineChats dataLoading={DataLoading} jsonData={dataItems} />
                      <Analtyics
                        dataLoading={DataLoading}
                        jsonData={dataItems}
                      />
                    )}

                    {DataLoading && (
                      <>
                        <Skeleton height="400px" />
                        <span style={{ paddingTop: "10px", display: "block" }}>
                          Thank you for your patience! We're in the process of
                          gathering the data needed to create your graph
                        </span>
                      </>
                    )}
                  </CustomTabPanel>
                </Box>
              </div>
            </>
          ) : (
            <>
              <div id="main">
                <div
                  style={{
                    textAlign: "center",
                    display: "grid",
                    alignItems: "center",
                    alignContent: "center",
                    height: "100%",
                  }}
                >
                  <h1 class="w3-jumbo w3-animate-top w3-center">
                    <code>Access Denied</code>
                  </h1>
                  <h4 class="w3-center w3-animate-right">
                    You dont have permission to view this page.
                  </h4>
                  <h3 class="w3-center w3-animate-zoom">🚫🚫🚫🚫</h3>
                  <h6 class="w3-center w3-animate-zoom">
                    error code:403 forbidden
                  </h6>
                </div>
              </div>
            </>
          )}

        </div>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </div>
  );
};

export default ManageUser;
